import { j as l } from "../../../jsx-runtime-B6kdoens.js";
import { useMemo as p } from "react";
import { c as f } from "../../../index-CROKJrb5.js";
import { c as d, f as b } from "../../../create-component-CBAeEoQ6.js";
import { a as x, F as C } from "../../../FormControlContext-C7A4R-3o.js";
import { u as v } from "../../../use-merged-contexts-B9BYBfk1.js";
const z = f({
  base: "focus-visible:cur-ring-offset-transparent focus-visible:cur-ring-transparent focus-visible:cur-outline-1 focus-visible:-cur-outline-offset-4 focus-visible:cur-outline-focus",
  variants: {
    size: {
      sm: "cur-py-[.6875rem] cur-px-2",
      md: "cur-py-[.9375rem] cur-px-3"
    },
    position: {
      start: "cur-order-first",
      end: "cur-order-last"
    },
    disabled: {
      true: "cur-text-disabled"
    }
  },
  compoundVariants: [
    {
      size: "md",
      position: "start",
      className: "-cur-mr-5"
    },
    {
      size: "sm",
      position: "start",
      className: "-cur-mr-3"
    },
    {
      size: "md",
      position: "end",
      className: "-cur-ml-5"
    },
    {
      size: "sm",
      position: "end",
      className: "-cur-ml-3"
    }
  ]
}), M = (s) => p(() => s === "sm" ? "sm" : "md", [s]), R = d(
  "FormControlDecoration",
  b(
    ({ as: s, children: t, className: e, onClick: o, position: i = "start", ...n }, a) => {
      const r = s || (o ? "button" : "div"), m = r === "button" ? { type: "button" } : {}, { disabled: c = !1, size: u = "md" } = v(
        C,
        x
      );
      return /* @__PURE__ */ l.jsx(
        r,
        {
          ...m,
          className: z({ size: u, position: i, disabled: c, className: e }),
          onClick: o,
          ref: a,
          ...n,
          children: t
        }
      );
    }
  )
);
export {
  R as FormControlDecoration,
  M as useDecorationIconSize
};
//# sourceMappingURL=index.js.map
